
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AccountsComponent } from './accounts.component';
import { GSTModule } from './gst/gst.module';
import { TDSModule } from './tds/tds.module';
import { AccountRoutingModule } from './account-routing-module.module';


@NgModule({
  imports: [
    CommonModule,
    // RouterModule.forChild(baseRoutes),
    AccountRoutingModule
  ],
  declarations: [AccountsComponent]
})
export class AccountModule { }


